import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  TimePicker,
  Checkbox,
} from 'antd';
import { find, isEmpty, sortBy } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { reactLocalStorage } from 'reactjs-localstorage';
import CityApi from '../../functions/api/partner/CityApi';
import DistrictApi from '../../functions/api/partner/DistrictApi';
import PartnerApi, { STATUS } from '../../functions/api/partner/PartnerApi';
import TypeApi from '../../functions/api/vehicle/TypeApi';
import ConvertPartner from '../../functions/ConvertPartner';
import ModalHoliday from './ModalHoliday';
import ModalProcedure from './ModalProcedure';
import ModalWday from './ModalWday';
import AddonApi from '../../functions/api/booking/AddonApi';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const STATUS_OPTIONS = [
  {
    value: STATUS.ACTIVE,
    label: 'ACTIVE',
  },
  {
    value: STATUS.INACTIVE,
    label: 'INACTIVE',
  },
];

const PARTNER_OPTIONS = [
  {
    value: 'Cá nhân',
    label: 'Cá nhân',
  },
  {
    label: 'Công ty',
    value: 'Công ty',
  },
];

class FormAddPartner extends Component {
  constructor(props) {
    super(props);

    const userInfo = reactLocalStorage.getObject('user.info');
    const partnerId = props.match.params.part_id ?? userInfo.user_part_id;

    this.state = {
      cities: [],
      districts: [],
      all_produces: [],
      all_wdays: [],
      all_holidays: [],
      all_paymenthods: [],
      userInfo,
      isPartner: userInfo.user_role_id === 3,
      listPartners: null,
      partnerId,
      selectedParterPicking: {},
      detail: null,
      optionPaymentMethods: [],
      listAddons: [],
      selectedAddon: [],
      isEdit: !!partnerId,
    };
  }

  formRef = React.createRef();

  componentDidMount = async () => {
    const { partnerId } = this.state;

    const list = await PartnerApi.getAll();
    if (list) this.setState({ listPartners: list });

    let selectedParterPicking = partnerId
      ? find(list, { part_id: Number(partnerId) })
      : {};

    selectedParterPicking.part_stat_time = moment(
      selectedParterPicking.part_stat_time,
      'HH:mm:ss'
    );

    selectedParterPicking.part_end_time = moment(
      selectedParterPicking.part_end_time,
      'HH:mm:ss'
    );

    if (selectedParterPicking.part_pay_acc) {
      selectedParterPicking.part_pay_acc_number =
        selectedParterPicking.part_pay_acc.bank_number ?? '';
      selectedParterPicking.part_pay_acc_bank =
        selectedParterPicking.part_pay_acc.bank_name ?? '';
      selectedParterPicking.part_pay_acc_holder =
        selectedParterPicking.part_pay_acc.bank_holder ?? '';
    }

    var types, all_holidays, all_produces, all_wdays, all_paymenthods;
    types = await TypeApi.getAll();
    types = types ? types : [];

    all_holidays = await PartnerApi.getAllHolidays();
    all_holidays = all_holidays ? all_holidays : [];

    all_paymenthods = await PartnerApi.getAllPaymenthods();

    const optionPaymentMethods = await this.getOptionPaymentMethods(
      all_paymenthods
    );

    all_produces = await PartnerApi.getProcedures();
    all_produces = all_produces ? all_produces : [];

    all_wdays = await PartnerApi.getAllWdays();
    all_wdays = all_wdays ? all_wdays : [];

    const cities = await CityApi.getAll();
    const districts = await DistrictApi.getAll();
    const addOns = await AddonApi.getFacilitationAddOn();

    let listAddons = [];

    addOns.forEach((item) => {
      listAddons.push({
        label: item.name,
        value: Number(item.id),
      });
    });

    this.setState({
      cities: cities,
      districts: districts,
      types,
      all_holidays,
      all_produces,
      all_wdays,
      all_paymenthods,
      optionPaymentMethods,
      listAddons,
    });

    if (partnerId) {
      let detail = await PartnerApi.getDetailPartner(partnerId);
      const option = ConvertPartner.converParnerEdit(detail);
      let selectedAddon = [];
      if (!isEmpty(detail.addons)) {
        selectedAddon = detail.addons.map((addon) => {
          return Number(addon.addon_id);
        });
      }

      selectedParterPicking = Object.assign({}, option, selectedParterPicking);
      selectedParterPicking.pays = selectedParterPicking.pays.split(',');
      this.setState({ selectedParterPicking, selectedAddon });
    }
  };

  onChangeManyOption = (name, data) => {
    this.formRef.current.setFieldsValue({
      [name]: data,
    });
  };

  submitForm = async (values) => {
    console.log(values);

    const { cities, partnerId, districts } = this.state;

    let payload = {
      ...values,
    };

    const city = payload.city_id
      ? find(cities, { city_id: payload.city_id })
      : [];
    payload.city_name = city.city_name;

    const district = payload.district_id
      ? find(districts, { district_id: payload.district_id })
      : [];
    payload.district_name = district.district_name;

    payload.part_stat_time = ConvertPartner.convertTime(
      moment(payload.part_stat_time).format('LT').toString()
    );

    payload.part_end_time = ConvertPartner.convertTime(
      moment(payload.part_end_time).format('LT').toString()
    );

    const check = ConvertPartner.handleCheck(payload);

    if (check) {
      message.error('Dữ liệu bạn nhập còn thiếu :' + check[0] + ' là bắt buộc');
      return;
    }

    const partner = ConvertPartner.handleNew(payload);
    let data = Object.assign(payload, partner);
    let result;
    if (this.state.isEdit) {
      data.part_id = partnerId;
      result = await PartnerApi.editPartner(data);
    } else {
      result = await PartnerApi.createPartner(data);
    }

    if (result) {
      message.success('Lưu đối tác thành công');
    } else {
      message.error('Lỗi bạn');
    }
  };

  getOptionPaymentMethods = async (all_paymenthods) => {
    return all_paymenthods.map((p) => {
      return {
        value: p.pay_meth_name,
        label: p.pay_meth_name,
      };
    });
  };

  onChangeCity = async (cityId) => {
    const { cities } = this.state;
    let districts = [];
    if (cityId) {
      districts = await DistrictApi.getDistrictByCityId(cityId);
    }
    const city = find(cities, { city_id: cityId });
    if (!isEmpty(city)) {
      this.formRef.current.setFieldsValue({
        part_lat: city.city_lat,
        part_lng: city.city_long,
      });
    }

    if (isEmpty(districts)) {
      this.formRef.current.setFieldsValue({
        district_id: null,
      });
    }

    this.setState({
      districts: districts,
    });
  };

  render() {
    const {
      cities,
      districts,
      types,
      isPartner,
      selectedParterPicking,
      optionPaymentMethods,
      listAddons,
      selectedAddon,
      isEdit,
    } = this.state;

    if (isEmpty(selectedParterPicking) && isEdit) {
      return <Spin />;
    }

    selectedParterPicking.selectedAddon = selectedAddon;

    return (
      <div>
        {!isPartner ? (
          <h1>{this.state.isEdit ? 'Sửa đối tác' : 'Thêm đối tác'}</h1>
        ) : null}
        <Form
          {...formItemLayout}
          initialValues={selectedParterPicking}
          onFinish={this.submitForm}
          ref={this.formRef}
        >
          <Card className="mb-4" title="Thông tin cơ bản">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={['part_name']}
                  rules={[{ required: true }]}
                  label="Tên đối tác"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={['part_addr']}
                  label="Địa chỉ"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name={['part_phon']} label="Hotline">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_emai']} label="Email">
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name={['partner_owner']} label="Pháp nhân">
                  <Select
                    showArrow
                    style={{ width: '100%' }}
                    options={PARTNER_OPTIONS}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name={['tax_code']} label="Mã số thuế">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['tax_code_issue_date']} label="Ngày cấp">
                  <Input type="date" />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card title="Thông tin chi tiết">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={['vhc_type_id']}
                  label="Loại xe"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    disabled={isEdit}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={sortBy(types, ['vhc_type_name']).map((p) => ({
                      value: p.vhc_type_id,
                      label: p.vhc_type_name,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name="city_id"
                  label="Thành phố"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    onChange={this.onChangeCity}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={sortBy(cities, ['city_name']).map((c) => ({
                      value: c.city_id,
                      label: c.city_name,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name="district_id" label="Quận">
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    options={sortBy(districts, ['district_name']).map((d) => ({
                      value: d.district_id,
                      label: d.district_name,
                    }))}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={['part_addr_shor']}
                  label="Địa chỉ thu gọn"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['part_lat']}
                  rules={[{ required: true }]}
                  label="Latitude"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['part_lng']}
                  rules={[{ required: true }]}
                  label="Longitude"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item name={['part_web']} label="Website">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_pay_acc_number']} label="Số tài khoản">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_pay_acc_bank']} label="Ngân hàng">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_pay_acc_holder']} label="Chủ tài khoản">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_ctac_name']} label="Tên liên lạc">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_ctac_mobi']} label="Số liên lạc">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['part_deli_free_km']}
                  label="Số km giao miễn phí"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['part_deli_over_km_fee']}
                  label="Phí giao xe trên 1 km"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['part_lim_km']} label="Giới hạn km">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['commission']}
                  label="Hoa hồng Chungxe được nhận"
                  extra="(Giá trị nhỏ hơn 100 thì là %, lớn hơn 100 thì là số tiền)"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['part_over_km_fee']}
                  label="Phí phụ trội theo km"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['part_over_time_fee']}
                  label="Phí phụ trội theo giờ"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name={['pays']}
                  label="Phương thức thanh toán"
                  rules={[{ required: true }]}
                >
                  <Select
                    mode="multiple"
                    showArrow
                    style={{ width: '100%' }}
                    options={optionPaymentMethods}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>

              <Col span={3}>
                <Form.Item name={['part_stat_time']} label="Bắt đầu">
                  <TimePicker minuteStep={30} format="HH:mm" />
                </Form.Item>
              </Col>

              <Col span={3}>
                <Form.Item name={['part_end_time']} label="Kết thúc">
                  <TimePicker minuteStep={30} format="HH:mm" />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  label="Có giao xe tại nhà không ?"
                  name={['part_deli_home']}
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Có giao xe từ tối hôm trước không ?"
                  name={['part_last_nigh_supt']}
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>

              <Col span={6}>
                <ModalProcedure
                  onChangeManyOption={this.onChangeManyOption}
                  procs={selectedParterPicking?.procs}
                  procs_detail={selectedParterPicking?.procs_detail}
                />
              </Col>

              {!isPartner ? (
                <Col span={6}>
                  <ModalHoliday
                    holis={selectedParterPicking?.holis}
                    onChangeManyOption={this.onChangeManyOption}
                  />
                </Col>
              ) : null}

              <Col span={6}>
                <ModalWday
                  onChangeManyOption={this.onChangeManyOption}
                  wdays={selectedParterPicking?.wdays}
                />
              </Col>

              <Col span={6}>
                <Form.Item
                  name={['status']}
                  label="Trạng thái"
                  rules={[{ required: true }]}
                >
                  <Select
                    defaultValue="ACTIVE"
                    showArrow
                    style={{ width: '100%' }}
                    options={STATUS_OPTIONS}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['selectedAddon']} label="Bảo lãnh">
                  <Checkbox.Group options={listAddons} />
                </Form.Item>
              </Col>

              <Col span={16}>
                <Form.Item name={['part_polc']} label="Chính sách">
                  <Input.TextArea rows={10} />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Button
              onClick={() => this.props.history.push('/partner')}
              type="default"
            >
              Quay lại
            </Button>
          </Space>
        </Form>
      </div>
    );
  }
}

export default withRouter(FormAddPartner);
